// zn.js
export default {
  main:{
    // 版本更新
    YouMightNeedToRefreshTheCurrentWebPage: "发现一个新版本，点击确定立即前往！",
    IncludingShippingFreight: "含运费:",
    // 通用头部国际化【完成】
    home: "首页",
    productCenter: "产品中心",
    pleaseEnter: "请输入",
    login:"登录",
    register: "注册",
    personCenter:"个人中心",
    logout: "退出登录",
    nopic: "暂无图片",
    confirmOperate :"您确定要执行该项操作吗?",
    tip:"提示",
    sure: "确认",
    cancel: "取消",
    invalidRequest:"很抱歉，我们似乎找不到您要查找的页面。",
    goHome:"返回首页",
    PleaseEnableBrowserCookies:"请启用浏览器cookie。",

    // 右侧悬浮工具国际化【完成】
    onlineService:"区域销售经理",
    shareToEmail:"分享至邮箱",
    yourEmail: "您的邮箱",
    friedEmail: "朋友邮箱",
    comments: "留言/评论",
    shareContent:"这个网页上的产品也许是你感兴趣的，希望对你有所帮助！",
    send:"发 送",
    operationCompletedSuccessfully:"操作成功",

    // 通用footer国际化【完成】
    professionalManufacturerOfOpticalComponents: "专业的光学元件生产商，您值得信赖的合作伙伴！",
    followUs: "关注我们",
    companyNews: "新闻动态",
    contactUs: "联系我们",
    serviceHotline:"热线电话",
    serviceHotlineTime:"( 周一至周五9:00-18:00 )",
    serviceHotlineTel:"027-87734955 / 87561503 / 87531507",
    email: "邮箱",
    emailAddress: "sales@u-optic.com",
    emailSubject: "咨询优光科技",
    fax: "传真",
    faxNum: "027 87531525",
    companyAddress:"公司地址：武汉市东湖开发区高新二路388号生物医药加速器19栋",

    // 首页国际化【完成】
    noData:"暂无数据",
    aboutUs:"关于优光",
    aboutUsContent:"武汉优光科技有限责任公司(Union Optic)成立于2004年，是专业从事精密光学元件研发、生产、销售的高新技术企业，2022年被工信部授予“专精特新”小巨人企业称号！优光科技座落于美丽的江城武汉，位于高新技术企业云集的东湖新技术开发区。优光科技现有办公厂房面积21000多平米，员工500余人，其中各类专业技术人员约占员工总数的25%。优光科技拥有光学设计、精密光学加工、光学镀膜以及精密光学装配等技术和工艺，拥有完整的生产线和各种先进的加工、检测设备，完善的企业管理系统和质量管理体系，公司致力于为客户提供中小批量高精度光学元件及大批量规模生产的光学元件。",
    viewMore:"查看更多",

    // 联系我们 国际化【完成】
    telephoneExchange:"总机号码",
    telephoneExchangeTel:"027-87531507/87561507",
    salesHotline: "销售热线",
    salesHotlineTel:"027-87734955/87561503",
    businessCooperation:"商务合作",
    companyFax:"公司传真",
    businessMail:"公司邮箱",
    technicalSupport:"技术支持",
    technicalSupportTel:"027-87531507" +
        "<br>或87561507转8006或8007",
    gwzc: "岗位职责",
    gwyq: "岗位要求",

    // 网站地图 国际化【完成】
    Sitemap: "网站地图",

    // 服务条款国际化【完成】
    TermsConditions: "服务条款",
    PrivacyPolicy: "我们通过使用Cookie优化网站内容，持续为您提供良好的服务，确认按钮“OK”即视为您已阅读我们的隐私政策并同意其中的条款。",

    // 产品目录国际化【完成】
    catalogues: "产品目录",
    updateTime: "更新时间",
    EDownload: "电子版下载",
    PaperRequest: "纸质版申请",
    FirstName:"姓",
    LastName:"名",
    Country:"国家",
    Company:"单位",
    Address:"地址",
    telephone: "电话",
    ZipCode:"邮编",

    // 新闻列表【完成】

    // 新闻详情【完成】
    nextPage: "下一篇",
    beforePage: "上一篇",

    // 购买流程 列表【完成】
    nextP: "下一页",
    beforeP: "上一页",

    // 产品分类封面【完成】

    // 产品分类更多【完成】
    myOrder: "我的订单",
    myInquiry: "我的咨询",

    // 产品分类详情页
    productFeatures: "产品特点",
    productDetail: "产品详情",
    productBuild: "产品定制",
    feedback: "意见反馈",
    Overview: "概述",
    Specifications: "规格",
    CoatingCurve: "曲线",  //镀膜曲线图
    Drawing: "尺寸图",
    Mark: "标识",
    SelectionGuide: "选型指南",
    Feedback: "反馈",
    Illustration: "机械尺寸图",
    RetardationCurve: "相位曲线图",
    Datasheet: "数据表",
    Specification: "规格书",
    FeedbackContent: "反馈内容",
    clear: "清空",
    search: "搜索",
    all: "全部",
    standardProductAbbr: "标准产品",
    standardProduct: "标准产品",
    frequentlyUsedProductAbbr: "常用产品",
    frequentlyUsedProduct: "常用产品",
    parameter: "参数",
    product: "产品名称",
    partNumber: "型号",
    priceForOne: "单价",
    totalPrice:"总价",
    monetaryUnit:"￥",
    amountConvert:"￥ <span class='color-635796'>{amount}</span>",
    commit: "提交",
    compare: "产品比对",
    shopCar: "购物车",
    addShopCar: "加入购物车",
    addInquiry: "请咨询",
    productInquiry: "产品咨询",
    download: "下载",
    chooseShopNum: "已选择商品： <span class='color-635796'>{num}</span> 件",
    OnlyShowItemsInStock:"仅显示有库存商品",
    remark: "备注",
    fieldIsRequired: "请输入 {field}",
    fieldIsError: "{field} 格式不正确",

    // 购物车国际化
    pleaseSelectProduct:"请选择商品",
    pleaseSelectAddress:"请选择地址",
    pleaseSelectBilling:"请选择发票地址",
    pleaseSelectBillingType:"请选择发票类型",

    // 注册页面国际化
    Registration:"欢迎注册",
    MemberLogin: "会员登录",
    passwordFinding: "找回密码",
    thePasswordsDoNotMatch:"两次密码不匹配",
    registrationAgreement:"您还没有同意注册协议",

    // 登录页国际化
    passwordLogin:"密码登录",
    emailLogin:"邮箱登录",
    telephoneLogin:"短信登录",
    // 密码登录
    account: "账号",
    enterMailPhone: "请输入邮箱/手机号",
    password:"密码",
    pleaseEnterYourPassword: "请输入密码",
    forgetPassword: "忘记密码？",
    Captcha:"验证码",
    pleaseEnterYourCaptcha: "请输入验证码",
    loginCode:"验证码",
    pleaseEnterYourLoginCode: "请输入验证码",
    sendLoginCode: "发送验证码",
    rememberMe: "记住密码",
    noAccount: "没有账号?",
    // 邮箱登录
    emailAccount:"邮箱",
    enterMail: "请输入邮箱",
    // 短信登录
    telephoneAccount: "+86",
    enterTelephone: "请输入手机号",

    // 找回密码
    retypePassword:"确认密码",
    PleaseConfirmYourPassword: "请再次输入密码",
    hasAccount: "已有账号？",

    // 注册
    readAndAccept:"我已阅读并接受",
    termsConditions:"《本站版权声明和服务条款》",

    //  用户中心
    userCenterSearchPlaceholder: "商品名称/商品型号/订单号/..",
    MyAddress: "收货地址",
    Invoice:"发票信息",
    MyProfile:"个人资料",
    ChangePassword:"修改密码",
    addressList: "收货地址列表",
    addAddress: "新增收货地址",
    Name:"姓名",
    defaultAddress: "默认地址",
    setDefault: "设为默认",
    ConsigneeInformation: "地址信息",
    receiver: "联系人",
    country:"国家",
    city:"城市",
    orderCompany: "单位",
    addressDetail: "详细地址",
    AddressLine1: "详细地址",
    AddressLine2: "详细地址",
    AddressLine3: "详细地址",
    postalCode:"邮编",
    ToBePaid:"待支付",
    ToBeShipped:"待发货",
    ToBeReceived:"待收货",
    Completed:"已完成",
    Cancelled:"已取消",
    Deleted:"回收站",
    HasDeleted:"已删除",
    OrderList:"订单列表",
    InquiryList:"咨询列表",
    consignee: "收件人",
    amountOfMoney: "总金额",
    Status:"状态",
    Manage:"管理",
    OrderNumber:"订单号",
    InquiryNumber:"咨询号",
    OrderDate:"下单时间",
    InquiryDate:"咨询时间",
    totalNum:"总数量",
    OldPassword: "原密码",
    NewPassword: "新密码",
    RetypeNewPassword: "确认新密码",
    edit: "编辑",
    delete: "删除",
    nickname:"昵称",
    title: "标题",
    suggestionsDetail: "意见详情",
    person: "个人",
    addInvoice: "新增发票信息",
    TaxpayerIdentificationNumber:"纳税人识别号",
    CompanyAddress:"单位地址",
    CompanyPhone: "电话",
    BankName: "开户银行",
    BankAccount: "银行账户",
    defaultInvoice: "默认发票",
    receiveEmail: "收票人邮箱",
    InvoiceInfo:"发票信息",
    InvoiceType: "发票类型",
    OwnerType:"抬头类型",
    PayNow: "去付款",
    ConfirmReceipt:"确认收货",
    ViewContract:"查看合同",
    ViewQuotation:"查看报价单",
    orderDetail:"订单详情",
    Detail:"查看详情",
    OrderingInformation:"订单信息",
    ProductType:"产品类型",
    OnlineProducts:"在线产品",
    LogisticsInformation:"物流信息",
    LogisticsCompany:"物流公司",
    LogisticsNumber:"物流单号",
    deliveryTime:"发货时间",
    invoiced:"已开票",
    NotInvoiced:"未开票",
    Item: "序号",
    ProductSpecifications:"产品规格",
    RepeatOrder:"再次订购",

    // 产品比对页面
    DownloadToExcel: "下载Excle表",
    pleaseEnterPartNumber: "请输入产品型号",
    add: "添加",
    showAllSpecifications: "显示所有参数",
    showSelectedSpecifications: "显示所选参数",
    view:"查看",
    sendTo: "配送至",
    freight: "运费",
    SelectAnAddress: "请选择配送地址",
    SelectAll: "全选",
    subTotal: "小计",
    shopCarNum: "数量",
    StockNum:"库存数量",
    varName_stock:"库存",
    varName_price:"单价",
    AddAllToInquiry:"加入咨询清单",
    DeleteSelected:"删除选中商品",
    clearShopCar: "清除购物车",
    clearInquiryCart: "清除全部产品",
    toSettle: "提交订单",

    // 结算页
    AddressInformation: "地址信息",
    ShippingInformation: "物流配送",
    ReviewPayment: "确认及支付",
    searchAddress: "从地址簿搜索",
    searchBilling: "从发票簿搜索",
    PlainInvoice: "电子普通发票",
    SpecialInvoice: "电子专用发票",
    PaperSpecialInvoice: "纸质专用发票",
    SameAsShipping: "同发货地址",

    settlement:"结算页",
    MyShopCar: "我的购物车",
    ConfirmingAnOrder: "核对订单信息",
    Payment:"完成购买",
    NotRequiredInvoice:"不开发票",
    ElectronicInvoices: "电子发票",
    Cut:"收起",
    More:"更多",

    // 付款页面
    PaymentPage:"付款页",
    OrderInformationHasBeenEntered:"您已提交订单",
    ChoosePaymentMethod: "选择支付方式",
    PaymentQRcode:"支付二维码",
    paySucess:"我已支付",
    pleaseScan:"请使用微信扫描二维码完成支付",
    pleaseSurePayStatus:"请确认支付状态",
    paypalNote:"注意：您使用信用卡支付时，将通过PayPal系统直接在线处理。",
    PurchaseOrderNote:"请完善您的采购信息",
    purchaseOrderNo:"采购订单号",
    ContactPhone:"采购联系人电话",
    ContactEmail:"采购联系人邮箱",

    //付款结果页面
    PayedToDertail:"购买成功，我们将尽快为您处理！",
    PayedError:"非常抱歉，我们暂时未收到支付成功的通知，很可能是网络延迟，建议您稍后查看支付状态或联系客服！",

    // 搜索结果
    SearchResults:"热门搜索",
    SearchResultsLang:"本站为您找到 {keyword} 的相关产品共 {num} 个。",

  }
};
